declare var dataLayer: any;

const joinForms = document.querySelectorAll<HTMLFormElement>(
    "form[data-join-step]"
);

function trackDomestic(joinForm: HTMLFormElement, step: string) {
    // Step 1.1 - Membership Status
    if (step == "membership-status") {
        trackStepMembershipStatus(joinForm, "quoteStep1.1", "Step 1.1");
    }

    // Step 2 - Cover Selection
    if (step == "what-cover") {
        trackStepWhatCover(joinForm);
    }

    // Step 3 - Details
    if(step == "details") {
        trackStepDetails(joinForm, "quoteStep3", "Step 3");
    }

    // Step 4 - Lead Capture
    if(step == "lead-capture") {
        trackStepLeadCapture(joinForm);
    }

    // For Hospital Selection, See HTML implementation in the Hospital Step View.
    // For Extras Selection, See HTML implementation in the Hospital Step View.
}

function trackOverseas(joinForm: HTMLFormElement, step: string) {

    // Step 1.1 - Overseas Purpose
    if (step == "overseas-purpose") {
        trackStepOverseasPurpose(joinForm);
    }

    // Step 2 - Membership Status
    if (step == "membership-status") {
        trackStepMembershipStatus(joinForm, "quoteStep2", "Step 2");
    }

    // Step 3 - Details
    if(step == "details") {
        trackStepDetails(joinForm, "quoteStep3", "Step 3");
    }

    // Step 4 - Lead Capture
    if(step == "lead-capture") {
        trackStepLeadCapture(joinForm);
    }

    // For Hospital Selection, See HTML implementation in the Hospital Step View.
    // For Extras Selection, See HTML implementation in the Hospital Step View.
}

function calculateAge(dob) {
    var diff_ms = Date.now() - dob.getTime();
    var age_dt = new Date(diff_ms);
    return String(Math.abs(age_dt.getUTCFullYear() - 1970));
}

function trackStepResidency(joinForm: HTMLFormElement) {
    joinForm.addEventListener("submit", () => {
            const selectedResidencyElem = document.querySelector('input[name="Residency"]:checked');
        
            dataLayer.push({
                event: "quoteStep1",
                step_number: 'Step 1',
                residencyStatus: selectedResidencyElem.dataset.analyticsValue,
            });

        }
    );
}

function trackStepOverseasPurpose(joinForm: HTMLFormElement) {
    joinForm.addEventListener("submit", () => {
        dataLayer.push({
            event: "quoteStep1.1",
            step_number: "Step 1.1",
            visitorType: window.Westfund.AnalyticsData.visitorType
        });
    });
}

function trackStepMembershipStatus(joinForm: HTMLFormElement, eventName: string, stepNumber: string) {
    joinForm.addEventListener("submit", () => {
        const formData = new FormData(joinForm);
        const memberStatus = formData.get("MemberStatus") || "new";

        dataLayer.push({
            event: eventName,
            step_number: stepNumber,
            visitorType: window.Westfund.AnalyticsData.visitorType,
            memberType: memberStatus == "new" ? 'non-member' : 'member'
        });
    });
}

function trackStepDetails(joinForm: HTMLFormElement, eventName: string = "quoteStep3", stepNumber: string = "Step 3") {
    joinForm.addEventListener("submit", () => {
        const formData = new FormData(joinForm);

        const mainAge = formData.get("MainAgeRangeLabel") as string;
        const coverType = formData.get("CoverType") as string;
        const state = formData.get("State") as string;
        const visaSubclass = formData.get("VisaType") as string;

        let partnerAge = '';
        if (hasPartner(coverType)) {
            partnerAge = formData.get("PartnerAgeRangeLabel") as string;
        }

        const detailsData = {
            event: eventName,
            coverType: coverType,
            state: state,
            mainAge: mainAge,
            govtRebateTier: formData.get("GovtRebateTier") as string,
            pregnancyOnly:
                (formData.get("PregnancyOnly") as string) === "true"
                    ? "true"
                    : "false",
            visitorType: window.Westfund.AnalyticsData.visitorType,
            coverSelection: window.Westfund.AnalyticsData.cover,
            originCountry: 'Australia',
            memberType: window.Westfund.AnalyticsData.memberType
        };
        if(partnerAge !== '') {
            detailsData.partnerAge = partnerAge;
        }

        // We no longer have access to origin country for overseas visitors
        if (window.Westfund.IsOverseas) {
            detailsData.originCountry = '';
            detailsData.visaSubclass = visaSubclass;
        }

        if (stepNumber && stepNumber !== '') {
            detailsData.step_number = stepNumber;
        }
        dataLayer.push(detailsData);
    });
}

function trackStepWhatCover(joinForm: HTMLFormElement) {
    joinForm.addEventListener("submit", () => {
        const formData = new FormData(joinForm);
        const cover = formData.get("Cover") || "";

        dataLayer.push({
            event: "quoteStep2",
            step_number: "Step 2",
            coverSelection: (cover === 'hospital-extras')
                ? "Hospital & Extras"
                : "Ambulance Cover",
            visitorType: window.Westfund.AnalyticsData.visitorType,
            memberType: window.Westfund.AnalyticsData.memberType
        })
    });
}

function trackStepLeadCapture(joinForm: HTMLFormElement) {
    joinForm.addEventListener("submit", () => {
        const formData = new FormData(joinForm);
        const analytics = window.Westfund.AnalyticsData || {};

        const leadCapture = {
            event: "quoteStep4",
            step_number: 'Step 4',
            coverType: analytics.coverType || '',
            state: analytics.state || '',
            mainAge: analytics.mainAge || '',
            govtRebateTier: analytics.govtRebateTier || '',
            pregnancyOnly: analytics.pregnancyOnly || 'false',
            visitorType: analytics.visitorType || '',
            coverSelection: analytics.cover || '',
            originCountry: analytics.originCountry || 'Australia',
            memberType: window.Westfund.AnalyticsData.memberType
        };
        if (hasPartner(analytics.coverType)) {
            leadCapture.partnerAge = analytics.partnerAge || '';
        }
        if (window.Westfund.IsOverseas) {
            leadCapture.visaSubclass = window.Westfund.AnalyticsData.visaSubclass;
        }

        dataLayer.push(leadCapture);
    });
}

function isFamily(coverType) {
    if(coverType === "family") {
        return true;
    }
    else if(coverType === "extendedfamily") {
        return true;
    }
    else if(coverType === "disabilityfamily") {
        return true;
    }
    return false;
}

// Cover types that include a second adult, and so have a partnerAge to report.
function hasPartner(coverType) {
    return isFamily(coverType) || coverType === "couple";
}

joinForms.forEach((joinForm) => {
    const getSelectOptionText = (name: string): string => {
        const formData = new FormData(joinForm);
        const selectValue = formData.get(name);
        const selectElement = joinForm.querySelector(`[name="${name}"]`) as HTMLSelectElement;
        if (selectElement) {
            const selectedOption = selectElement.querySelector(`option[value="${selectValue}"]`);
            const isHidden = selectElement.closest('.hidden');

            return (isHidden)
                ? ''
                : (selectedOption?.innerHTML || '').trim();
        }
        return '';

    }
    
    if (joinForm !== null) {
        const step = joinForm.getAttribute("data-join-step");

        if(step == "edit" || step == "semantic-statement") {
            trackStepDetails(joinForm, "coverDetailsUpdated", "");
        }
        
        // Step 1 - Residency
        if (step === "residency") {
            trackStepResidency(joinForm);
        }

        if (window.Westfund.IsOverseas) {
            trackOverseas(joinForm, step);
        } else {
            trackDomestic(joinForm, step);
        }
        
        
        // Below are the non refactored steps for tracking, this mainly includes the join process, the next time
        // we update the join process, we will refactor this section.
        switch (step) {
            case "tell-us-about-you":
                joinForm.addEventListener("submit", () => {
                    let locationType = '';
                    if (window.Westfund.AnalyticsData.visitorType === 'Overseas') {
                        locationType = document.querySelector('[name="VisaInAustralia"]:checked').value === 'Y'
                            ? 'onshore'
                            : 'offshore';
                    }


                    const aboutYouData = {
                        'event': 'aboutYouStep1',
                        'flow_section': 'About You',
                        'step_number': 'Step 1',
                        'visitorType': window.Westfund.AnalyticsData.visitorType,
                        'referral_channel': getSelectOptionText('HeardAbout'),
                        'coverType': window.Westfund.AnalyticsData.coverType,
                        'state': window.Westfund.AnalyticsData.state,
                        'hospitalCoverLevel': window.Westfund.AnalyticsData.hospitalCoverLevel,
                        'extrasCoverLevel': window.Westfund.AnalyticsData.extrasCoverLevel,
                        'coverSelection': window.Westfund.AnalyticsData.cover,
                        'locationType': locationType
                    };
                    aboutYouData.mainAge = window.Westfund.AnalyticsData.mainAge;
                    if(hasPartner(window.Westfund.AnalyticsData.coverType)) {
                        aboutYouData.partnerAge = window.Westfund.AnalyticsData.partnerAge;
                    }
                    if (window.Westfund.AnalyticsData.visitorType === 'Overseas') {
                        aboutYouData.visaSubclass = window.Westfund.AnalyticsData.visaSubclass;
                    }
                    dataLayer.push(aboutYouData);

                    
                });
                break;
            case "tell-us-about-you-contact":
                joinForm.addEventListener("submit", () => {
                    const formData = new FormData(joinForm);
                    const coverType = formData.get("Cover") || "";
                    const state = formData.get("MainHomeState") || formData.get("MainHomeStateOnly") || "";
                    
                    const data = {
                        'event': 'aboutYouStep2',
                        'flow_section': 'About You',
                        'step_number': 'Step 2',
                        'visitorType': window.Westfund.AnalyticsData.visitorType,
                        'coverSelection': window.Westfund.AnalyticsData.cover,
                        'coverType': window.Westfund.AnalyticsData.coverType,
                        'state': state,
                        'locationType': window.Westfund.AnalyticsData.locationType
                    };

                    data.mainAge = window.Westfund.AnalyticsData.mainAge;
                    if(hasPartner(window.Westfund.AnalyticsData.coverType)) {
                        data.partnerAge = window.Westfund.AnalyticsData.partnerAge;
                    }
                    if (window.Westfund.AnalyticsData.visitorType === 'Overseas') {
                        data.visaSubclass = window.Westfund.AnalyticsData.visaSubclass;
                    }
                    dataLayer.push(data);
                });
                break;
            case "tell-us-about-you-dependents":
                joinForm.addEventListener("submit", () => {

                    const data = {
                        'event': 'aboutYouStep3',
                        'flow_section': 'About You',
                        'step_number': 'Step 3',
                        'visitorType': window.Westfund.AnalyticsData.visitorType,
                        'locationType': window.Westfund.AnalyticsData.locationType
                    };

                    data.mainAge = window.Westfund.AnalyticsData.mainAge;
                    if(hasPartner(window.Westfund.AnalyticsData.coverType)) {
                        data.partnerAge = window.Westfund.AnalyticsData.partnerAge;
                    }
                    if (window.Westfund.AnalyticsData.visitorType === 'Overseas') {
                        data.visaSubclass = window.Westfund.AnalyticsData.visaSubclass;
                    }
                    dataLayer.push(data);
                });
                break;
            case "your-cover-rebate":
                joinForm.addEventListener("submit", () => {
                    const data = {
                        'event': 'yourCoverStep1',
                        'flow_section': 'Your Cover',
                        'step_number': 'Step 1',
                        'visitorType': window.Westfund.AnalyticsData.visitorType,
                        'coverSelection': window.Westfund.AnalyticsData.cover,
                        'coverType': window.Westfund.AnalyticsData.coverType,
                        'state': window.Westfund.AnalyticsData.state
                    };
                    
                    data.mainAge = window.Westfund.AnalyticsData.mainAge;
                    if(hasPartner(window.Westfund.AnalyticsData.coverType)) {
                        data.partnerAge = window.Westfund.AnalyticsData.partnerAge;
                    }
                    if (window.Westfund.AnalyticsData.visitorType === 'Overseas') {
                        data.visaSubclass = window.Westfund.AnalyticsData.visaSubclass;
                    }
                    dataLayer.push(data);
                    
                });
                break;
            case "why_choose":
            case "your-cover-transfer":

                if (window.Westfund.IsOverseas) {
                    joinForm.addEventListener("submit", () => {
                        const currentFund = getSelectOptionText('PreviousFundId');
                        const data = {
                            'event': 'aboutYouStep4',
                            'flow_section': 'About You',
                            'step_number': 'Step 4',
                            'visitorType': window.Westfund.AnalyticsData.visitorType,
                            'currentFund': currentFund || '',
                            'whyWestfund': getSelectOptionText('JoinReasonId'),
                            'locationType': window.Westfund.AnalyticsData.locationType,
                        };
                        data.mainAge = window.Westfund.AnalyticsData.mainAge;
                        if(hasPartner(window.Westfund.AnalyticsData.coverType)) {
                            data.partnerAge = window.Westfund.AnalyticsData.partnerAge;
                        }
                        if (window.Westfund.AnalyticsData.visitorType === 'Overseas') {
                            data.visaSubclass = window.Westfund.AnalyticsData.visaSubclass;
                        }
                        dataLayer.push(data);
                    });
                } else {
                    joinForm.addEventListener("submit", () => {
                        const data = {
                            'event': 'yourCoverStep2',
                            'flow_section': 'Your Cover',
                            'step_number': 'Step 2',
                            'visitorType': window.Westfund.AnalyticsData.visitorType,
                            'currentFund': getSelectOptionText('PreviousFundId'),
                            'whyWestfund': getSelectOptionText('JoinReasonId'),
                            'referral_channel': window.Westfund.AnalyticsData.referralChannel,
                            'coverType': window.Westfund.AnalyticsData.coverType,
                            'state': window.Westfund.AnalyticsData.state,
                            'hospitalCoverLevel': window.Westfund.AnalyticsData.hospitalCoverLevel,
                            'extrasCoverLevel': window.Westfund.AnalyticsData.extrasCoverLevel,
                            'coverSelection': window.Westfund.AnalyticsData.cover
                        };
                        data.mainAge = window.Westfund.AnalyticsData.mainAge;
                        if(hasPartner(window.Westfund.AnalyticsData.coverType)) {
                            data.partnerAge = window.Westfund.AnalyticsData.partnerAge;
                        }
                        if (window.Westfund.AnalyticsData.visitorType === 'Overseas') {
                            data.visaSubclass = window.Westfund.AnalyticsData.visaSubclass;
                        }
                        dataLayer.push(data);
                    });
                }

                break;
            case "your-cover-lhc":
                joinForm.addEventListener("submit", () => {
                    const data = {
                        'event': 'yourCoverStep3',
                        'flow_section': 'Your Cover',
                        'step_number': 'Step 3',
                        'visitorType': window.Westfund.AnalyticsData.visitorType,
                        'currentFund': window.Westfund.AnalyticsData.currentFund,
                        'whyWestfund': window.Westfund.AnalyticsData.whyWestfund,
                        'referral_channel': window.Westfund.AnalyticsData.referralChannel,
                        'coverSelection': window.Westfund.AnalyticsData.cover,
                        'coverType': window.Westfund.AnalyticsData.coverType,
                        'state': window.Westfund.AnalyticsData.state
                    };

                    data.mainAge = window.Westfund.AnalyticsData.mainAge;
                    if(hasPartner(window.Westfund.AnalyticsData.coverType)) {
                        data.partnerAge = window.Westfund.AnalyticsData.partnerAge;
                    }
                    if (window.Westfund.AnalyticsData.visitorType === 'Overseas') {
                        data.visaSubclass = window.Westfund.AnalyticsData.visaSubclass;
                    }
                    dataLayer.push(data);
                });
                break;
            case "your-cover-concession":
                joinForm.addEventListener("submit", () => {
                    const data = {
                        'event': 'yourCoverStep4',
                        'flow_section': 'Your Cover',
                        'step_number': 'Step 4',
                        'visitorType': window.Westfund.AnalyticsData.visitorType,
                        'currentFund': window.Westfund.AnalyticsData.currentFund,
                        'whyWestfund': window.Westfund.AnalyticsData.whyWestfund,
                        'referral_channel': window.Westfund.AnalyticsData.referralChannel,
                        'coverSelection': window.Westfund.AnalyticsData.cover,
                        'coverType': window.Westfund.AnalyticsData.coverType,
                        'state': window.Westfund.AnalyticsData.state
                    };
                    data.mainAge = window.Westfund.AnalyticsData.mainAge;
                    if(hasPartner(window.Westfund.AnalyticsData.coverType)) {
                        data.partnerAge = window.Westfund.AnalyticsData.partnerAge;
                    }
                    if (window.Westfund.AnalyticsData.visitorType === 'Overseas') {
                        data.visaSubclass = window.Westfund.AnalyticsData.visaSubclass;
                    }
                    dataLayer.push(data);
                });
                break;
            case "pay-promo":
                joinForm.addEventListener("submit", () => {
                    const formData = new FormData(joinForm);
                    const promoCode = formData.get("PromotionCodeId") || "";

                    const data = {
                        'event': 'paySubmitStep1',
                        'promoCode': promoCode,
                        'flow_section': 'Pay & Submit',
                        'step_number': 'Step 1',
                        'visitorType': window.Westfund.AnalyticsData.visitorType,
                        'currentFund': window.Westfund.AnalyticsData.currentFund,
                        'whyWestfund': window.Westfund.AnalyticsData.whyWestfund,
                        'referral_channel': window.Westfund.AnalyticsData.referralChannel,
                        'coverSelection': window.Westfund.AnalyticsData.cover,
                        'coverType': window.Westfund.AnalyticsData.coverType,
                        'state': window.Westfund.AnalyticsData.state,
                        'locationType': window.Westfund.AnalyticsData.locationType,
                    };
                    data.mainAge = window.Westfund.AnalyticsData.mainAge;
                    if(hasPartner(window.Westfund.AnalyticsData.coverType)) {
                        data.partnerAge = window.Westfund.AnalyticsData.partnerAge;
                    }
                    if (window.Westfund.AnalyticsData.visitorType === 'Overseas') {
                        data.visaSubclass = window.Westfund.AnalyticsData.visaSubclass;
                    }
                    dataLayer.push(data);
                });
                break;
            case "pay-start":
                joinForm.addEventListener("submit", () => {
                    const data = {
                        'event': 'paySubmitStep2',
                        'flow_section': 'Pay & Submit',
                        'step_number': 'Step 2',
                        'visitorType': window.Westfund.AnalyticsData.visitorType,
                        'currentFund': window.Westfund.AnalyticsData.currentFund,
                        'whyWestfund': window.Westfund.AnalyticsData.whyWestfund,
                        'referral_channel': window.Westfund.AnalyticsData.referralChannel,
                        'coverSelection': window.Westfund.AnalyticsData.cover,
                        'coverType': window.Westfund.AnalyticsData.coverType,
                        'state': window.Westfund.AnalyticsData.state,
                        'locationType': window.Westfund.AnalyticsData.locationType,
                    };
                    data.mainAge = window.Westfund.AnalyticsData.mainAge;
                    if(hasPartner(window.Westfund.AnalyticsData.coverType)) {
                        data.partnerAge = window.Westfund.AnalyticsData.partnerAge;
                    }
                    if (window.Westfund.AnalyticsData.visitorType === 'Overseas') {
                        data.visaSubclass = window.Westfund.AnalyticsData.visaSubclass;
                    }
                    dataLayer.push(data);
                });
                break;
            case "pay-terms":
                joinForm.addEventListener("submit", () => {
                    const data = {
                        'event': 'paySubmitStep3',
                        'flow_section': 'Pay & Submit',
                        'step_number': 'Step 3',
                        'visitorType': window.Westfund.AnalyticsData.visitorType,
                        'currentFund': window.Westfund.AnalyticsData.currentFund,
                        'whyWestfund': window.Westfund.AnalyticsData.whyWestfund,
                        'referral_channel': window.Westfund.AnalyticsData.referralChannel,
                        'coverSelection': window.Westfund.AnalyticsData.cover,
                        'coverType': window.Westfund.AnalyticsData.coverType,
                        'state': window.Westfund.AnalyticsData.state,
                        'locationType': window.Westfund.AnalyticsData.locationType,
                    };
                    data.mainAge = window.Westfund.AnalyticsData.mainAge;
                    if(hasPartner(window.Westfund.AnalyticsData.coverType)) {
                        data.partnerAge = window.Westfund.AnalyticsData.partnerAge;
                    }
                    if (window.Westfund.AnalyticsData.visitorType === 'Overseas') {
                        data.visaSubclass = window.Westfund.AnalyticsData.visaSubclass;
                    }
                    dataLayer.push(data);
                });
                break;
            case "pay-details":

                // Tracking is triggered on the submitted step on page load

                break;
            default:
                const memberIdMatches = window.location.href.match(/MemberId=([^&]*)/i);
                const isCorporate = window.location.href.match(/IsCorporate=1/i) !== null;
                if (memberIdMatches) {
                    dataLayer.push({
                        'membershipNumber': memberIdMatches[1],
                        'memberType': (isCorporate)
                            ? 'corporate'
                            : 'consumer',
                    });
                }
                break;
        }
    }

});

const formulateWrappers = [...document.querySelectorAll(".formulate-wrapper")];

if (formulateWrappers.length > 0) {
    formulateWrappers.forEach((wrapper) => {
        // Analytics spreadsheet row no. 10
        wrapper.addEventListener("formulate form: submit: success", (e) => {
            const form = e.target as HTMLFormElement;
            const appointmentTypeSelect = form.querySelector<HTMLSelectElement>(
                'select[aria-label="Appointment Type"]'
            );

            if (appointmentTypeSelect !== null) {
                const appointmentType = appointmentTypeSelect.value;
                dataLayer.push({event: "appointmentRequested", appointmentType});
            }
        });
    });
}
const socialShare = [...document.querySelectorAll(".social-share a")]

if (socialShare.length > 0) {
    socialShare.forEach((link) => {
        link.addEventListener("click", function () {
            const socialMedia = link.getAttribute("aria-label");
            const pageTitle = document.querySelector("meta[name='title']")?.getAttribute("content");
            dataLayer.push({
                event: "socialShare",
                social: socialMedia,
                pageTitle: pageTitle
            });
        });
    })
}